// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"efc4c5f7","273":"14333720","340":"254a8c0c","937":"e0dc0ef9"}[chunkId] + ".css";
};